import ProductLink from "./ProductLink";
import { useSelector, shallowEqual } from "react-redux";
import { getCurrentLandingPage } from "app/pages/LandingPage/landingPageSelector";
import { stripAllTags, unescapeHtml } from "app/utils/html/html";

const mapStateToProps = state => {
	const landingLayout = getCurrentLandingPage(state)?.layout;

	return {
		resolution: state.resolution,
		productsVisibility: state.productsVisibility,
		strategy: state.partner.strategy,
		source: state.marketing.source,
		utm: {
			medium: state.marketing?.utmMedium,
			source: state.marketing?.utmSource,
			campaign: state.marketing?.utmCampaign,
			content: state.marketing?.utmContent,
			term: state.marketing?.utmTerm,
		},
		merchTitle: unescapeHtml(
			stripAllTags(
				state?.merchandising?.current?.displayOptions?.smartDP?.merchandisingTitle || ""
			)
		),
		landingPageTitle: unescapeHtml(
			stripAllTags(landingLayout?.merchandisingTitleDesktop || "")
		),
	};
};

const ProductLinkContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <ProductLink {...props} {...stateProps} />;
};

export default ProductLinkContainer;
